import axios from 'axios';
import { useAuthStore } from '../stores/authStore';
import { useUiStore } from '../stores/uiStore';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? '',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        useAuthStore.getState().logout();
        window.location.href = '/login';
        return Promise.reject(error);
      }

      const message =
        error.response?.data?.error?.message ??
        error.message ??
        'An unexpected error occurred';

      useUiStore.getState().addToast({
        title: 'Error',
        description: message,
        variant: 'error',
      });
    }

    return Promise.reject(error);
  },
);

export { api };
